/**
 * Created by ChrisMuto on 6/28/17.
 */
import * as deviceActions from "./actions";
import { default as deviceReducers } from "./reducers";
import * as deviceTypes from "./types";
import * as deviceConstants from "./constants";

export { deviceReducers, deviceTypes, deviceActions, deviceConstants };

export default deviceReducers;



// WEBPACK FOOTER //
// ./src/modules/devices/index.js